export const modes = {
  month: "month",
  year: "year",
  decade: "decade",
}
